import React, {useState, useEffect, useContext} from 'react';
import {createPortal} from 'react-dom';

import {AppContext} from '../../../AppModule/Context';

import ToolTipComponent from './toolTipComponent';

import ResourcePermissionsService from '../../../services/resourcePermissionsService';

import ExclamationIcon from '../../../assets/svgComponents/exclamationIcon';
import VideoIcon from '../../../assets/svg/video_2.svg';
import MicIcon from '../../../assets/svg/mic.svg';
import VIDABOO_CONSTANTS from '../../../config/consts';

import './resourcePermissionsComponent.css';

const TOOLTIP_TYPE = {
  CAMERA: 'CAMERA',
  MICROPHONE: 'MICROPHONE',
};

const ResourcePermissionsComponent = ({
  permissionsStatusesObj = {},
  closePopUp = () => {},
  onPermissionsSuccess = () => {},
  onPermissionsFailure = () => {},
}) => {
  const context = useContext(AppContext);

  const [isCameraPermissionGranted, setIsCameraPermissionGranted] =
    useState(true);
  const [isMicrophonePermissionGranted, setIsMicrophonePermissionGranted] =
    useState(true);
  const [permissionPopupParentNode, setPermissionPopupParentNode] =
    useState(null);
  const [toolTipType, setToolTipType] = useState(null);

  const headerTxt =
    !isMicrophonePermissionGranted && !isCameraPermissionGranted
      ? context.languageSet.VIDEO_CALL_CAT.ENABLE_MICROPHONE_CAMERA
      : !isCameraPermissionGranted
        ? context.languageSet.VIDEO_CALL_CAT.ENABLE_CAMERA
        : context.languageSet.VIDEO_CALL_CAT.ENABLE_MICROPHONE;

  const subHeaderTxt =
    !isMicrophonePermissionGranted && !isCameraPermissionGranted
      ? context.languageSet.VIDEO_CALL_CAT
          .PLEASE_PROVIDE_ACCESS_TO_CAMERA_AND_MICROPHONE
      : !isCameraPermissionGranted
        ? context.languageSet.VIDEO_CALL_CAT.PLEASE_PROVIDE_ACCESS_TO_CAMERA
        : context.languageSet.VIDEO_CALL_CAT
            .PLEASE_PROVIDE_ACCESS_TO_MICROPHONE;

  useEffect(() => {
    if (permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA]) {
      setIsCameraPermissionGranted(
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] ===
          VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED,
      );
    }
    if (permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE]) {
      setIsMicrophonePermissionGranted(
        permissionsStatusesObj[
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
        ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED,
      );
    }
  }, [permissionsStatusesObj]);
  useEffect(() => {
    setPermissionPopupParentNode(
      document.getElementById('et-top-level-popup-portal-wrapper'),
    );
  }, []);
  const loudPermissionsRequest = async () => {
    const constraints = {
      audio:
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] &&
        permissionsStatusesObj[
          VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
        ] !== VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED,
      video:
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] &&
        permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] !==
          VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED,
    };
    try {
      await ResourcePermissionsService.loudGetPermissions(constraints);
      onPermissionsSuccess(constraints);
    } catch (error) {
      console.debug('Error', error);
      onPermissionsFailure(error);
    }
  };

  const onNeedHelpClicked = () => {
    window.open(
      VIDABOO_CONSTANTS.INSTRUCTIONS_LINKS.VIDEO_CALL_PERMISSIONS,
      '_blank',
    );
  };

  return (
    permissionPopupParentNode &&
    createPortal(
      <div
        className="et-n-resource-permission-component-container"
        onClick={closePopUp}>
        <div
          className="et-n-resource-permission-main-content-wrap"
          onClick={(e) => e.stopPropagation()}>
          <div className="et-n-rpc-header-wrap">{headerTxt}</div>
          <div className="et-n-rpc-permission-request-info-txt">
            {subHeaderTxt}
          </div>
          <div
            className={`et-n-rpc-permissions-icons-wrap ${
              isCameraPermissionGranted || isMicrophonePermissionGranted
                ? 'et-n-rpc-permissions-icons-wrap-single-icon'
                : ''
            }`}>
            {!isCameraPermissionGranted && (
              <div
                className="et-n-permission-icon-img-wrap"
                onClick={loudPermissionsRequest}>
                <img
                  className="et-n-permission-cam-icon-img"
                  src={VideoIcon}
                  alt="VideoIcon"
                />
                {permissionsStatusesObj[
                  VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA
                ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.NOT_SUPPORTED && (
                  <div
                    className="et-n-permission-camera-exclamation-icon"
                    onMouseEnter={() => {
                      setToolTipType(TOOLTIP_TYPE.CAMERA);
                    }}
                    onMouseLeave={() => {
                      setToolTipType(null);
                    }}>
                    <ExclamationIcon />
                    {toolTipType === TOOLTIP_TYPE.CAMERA && (
                      <ToolTipComponent
                        toolTipContainerStyle={{zIndex: 151}}
                        toolTipPosition="top"
                        toolTipTxt="Please enable the camera in your device's settings"
                      />
                    )}
                  </div>
                )}
              </div>
            )}
            {!isMicrophonePermissionGranted && (
              <div
                className="et-n-permission-icon-img-wrap"
                onClick={loudPermissionsRequest}>
                <img
                  className="et-n-permission-mic-icon-img"
                  src={MicIcon}
                  alt="MicIcon"
                />
                {permissionsStatusesObj[
                  VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE
                ] === VIDABOO_CONSTANTS.PERMISSION_STATUS.NOT_SUPPORTED && (
                  <div
                    className="et-n-permission-mic-exclamation-icon"
                    onMouseEnter={() => {
                      setToolTipType(TOOLTIP_TYPE.MICROPHONE);
                    }}
                    onMouseLeave={() => {
                      setToolTipType(null);
                    }}>
                    <ExclamationIcon />
                    {toolTipType === TOOLTIP_TYPE.MICROPHONE && (
                      <ToolTipComponent
                        toolTipContainerStyle={{zIndex: 151}}
                        toolTipPosition="top"
                        toolTipTxt="Please enable the microphone in your device's settings"
                      />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="et-n-rpc-need-help-txt-wrap">
            <div className="et-n-rpc-need-help-txt" onClick={onNeedHelpClicked}>
              {context.languageSet.VIDEO_CALL_CAT.NEED_HELP}
            </div>
          </div>
        </div>
      </div>,
      permissionPopupParentNode,
    )
  );
};

export default ResourcePermissionsComponent;
